<template>
  <!-- _________________________ VALIDATE ACCOUNT _________________________ -->
  <div id="login-div">

    <b-alert :show="ui.showError" class="mt-5" variant="danger">
      {{ $t('ValidateAccount.error') }}
      <br/>
    </b-alert>

    <div v-show="ui.showSuccess">
      <h1 class="page-title mt-5 bold-text confirm-email">
        {{ $t('ValidateAccount.success') }}
      </h1>
      <h1 class="page-subtitle mt-2 bold-text confirm-email">
        {{ $t('loginTitle') }}
      </h1>
      <p class="mt-3" v-html="$t('loginMailValidate')"></p>
    </div>

    <div class="mt-5">
      <b-button
        class="btn-block"
        variant="secondary"
        @click="backToLogin">
        {{ $t('backToLoginText') }}
      </b-button>
    </div>

  </div>
</template>

<script>

import api from '../../../services/api'

export default {

  name: 'ValidateAccountComponent',

  data() {
    return {
      token: this.$route.params.token,
      userId: this.$route.params.userId,
      ui: {
        showSuccess: false,
        showError: false
      }
    }
  },

  emits: ['showLoginView', 'alreadyValidate'],

  mounted() {
    this.validateAccount()
  },

  methods: {

    validateAccount() {
      const data = new FormData()
      data.append('token', this.token)
      data.append('userId', this.userId)

      api({
        method: 'POST',
        url: `/authentication/validateAccount`,
        data: data
      })
        .then((response) => {
          this.ui.showSuccess = true
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.ui.showErrorMessage = this.$i18n.t('Login.error')
            this.ui.showError = true
          }
          if (error.response.status === 403) {
            this.ui.showErrorMessage = this.$i18n.t(error.response.data.message)
            this.ui.showError = true
          }
          if (error.response.status === 409) {
            this.ui.showErrorMessage = this.$i18n.t(error.response.data.message)
            this.ui.showError = true
            this.$emit('alreadyValidate', this.ui.showErrorMessage)
          }
        })
    },

    backToLogin() {
      this.$emit('showLoginView')
    },

    goToHome() {
      if(this.$store.getters.isAgentImmo){
        this.$router.push({
          name: 'DashboardAgentImmo'
        })
      } else {
        this.$router.push({
          name: 'Dashboard'
        })
      }
    }

  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/auth/components/ValidateAccountComponent.vue